import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Content from '../../components/Articles/Content';

const Articles = ({getArticlesByPage}) => {
  return (
    <>
      <Content />
    </>
  );
};

export default Articles;

